<template>
  <div>
    <form-field-select
      :label="label"
      v-model="filterValue"
      placeholder="No filter"
      @change="handleInput"
    >
      <option
        v-for="option in options"
        :value="option.value"
        :key="option.value"
      >{{ option.label }}
      </option>
    </form-field-select>

    <form-field-date-picker
      v-show="filterValue === 'custom'"
      v-model="filterCustomValue"
      is-range
    ></form-field-date-picker>
  </div>
</template>

<script>
import {timeFrames} from "../../services/staticData";
import dates from "../../services/dates";

export default {
  name: "FilterTimeFrames",
  props: {
    label: {
      type: String,
      default: "Timeframes"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        // console.log('Store Module: ', this.storeModule);
        // console.log('Module Found: ', this.$store.state[this.storeModule]);
        // console.log('Name: ', this.$store.state[this.storeModule].filters[this.filterName]);
        // console.log('Timeframes: ', this.$store.state[this.storeModule].filters[this.filterName].timeFrames);
        return this.$store.state[this.storeModule].filters[this.filterName].timeFrames;
      },
      set(value) {
        // console.log('Value to be set via set method: ', value)
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "timeFrames",
          value
        ]);
      },
    },
    filterCustomValue: {
      get() {
        const value = this.$store.state[this.storeModule].filters[this.filterName].timeFrameValues
        if (! value) return []

        return [
          dates.getJSDate(value.start),
          dates.getJSDate(value.end)
        ]
      },
      set(value) {
        const customValue = {
          start: dates.convertJsDateToStartOf(value[0]),
          end: dates.convertJsDateToEndOf(value[1]),
        }

        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "timeFrames",
          this.filterValue,
          customValue
        ])
      }
    },
    options() {
      return [
        { value: null, label: 'All time' },
        ...timeFrames,
        { value: 'custom', label: 'Custom' }
      ];
    },
    text() {
      if (this.filterValue) {
        // console.log('Filter Value: ', this.filterValue);
        let timeFrame = timeFrames.find(timeFrame => timeFrame.value === this.filterValue);
        // console.log('Time Frame: ', timeFrame);
        if (this.filterValue === 'custom' && !timeFrame) return 'Updated Custom'

        return "Updated " + timeFrame.label;
      } else {
        return null;
      }
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
